import { Box, Chip, type ChipProps, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import {
  MasterlistCheckStatus,
  MasterlistJournalCheck,
} from '../../../../types/masterlistCheck.types';
import { ceasedSuffix, STATUS_LABEL_KEYS } from './masterlistCheck';

const CHIP_VARIANTS: Record<MasterlistCheckStatus, ChipProps['variant']> = {
  matches: 'success',
  check_issns: 'warning',
  confirm_match: 'secondary',
  not_found: 'default',
};

/**
 * A journal's masterlist status: one text chip, or plain text on mobile cards (a single
 * interactive element). The issue lines live in the journal modal.
 */
export function MasterlistStatus({
  id,
  check,
  compact = false,
}: {
  id: string;
  check: MasterlistJournalCheck;
  compact?: boolean;
}) {
  const { t } = useTranslation();
  const label = t(STATUS_LABEL_KEYS[check.status]);
  const ceased = ceasedSuffix(check, t);

  return (
    <Box id={id}>
      {compact ? (
        <>
          <Typography variant="caption" component="p">
            {t('agreements.masterlistCheck.columnHeader')}
          </Typography>
          <Typography variant="body1" component="span" fontWeight={600}>
            {label}
          </Typography>
        </>
      ) : (
        <>
          {/* Context for the row's aria-describedby, which reads this cell on its own. */}
          <span className="sr-only">
            {t('agreements.masterlistCheck.columnHeader')}:{' '}
          </span>
          <Chip
            size="small"
            variant={CHIP_VARIANTS[check.status]}
            label={label}
          />
        </>
      )}
      {ceased && <span>{ceased}</span>}
    </Box>
  );
}
